export function formatTimeLeft(ms: number) {
  if (!ms || ms <= 0) return '';

  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  const remainingHours = hours % 24;
  const remainingMinutes = minutes % 60;
  // const remainingSeconds = seconds % 60;

  let result = '';
  if (days > 0) result += `${days}d `;
  if (remainingHours > 0 || days > 0) result += `${remainingHours}h `;
  result += `${remainingMinutes}m`;

  return result.trim();
}

export function formatMsToDate(milliseconds: number) {
  const date = new Date(milliseconds);
  const locale = 'en-US';
  const options: Intl.DateTimeFormatOptions = { weekday: 'long', month: 'long', day: 'numeric' };

  return date.toLocaleDateString(locale, options).replace(/\d+/, (match) => {
    const ordinalNumber = Number.parseInt(match, 10);

    if (ordinalNumber % 100 >= 11 && ordinalNumber % 100 <= 13) {
      return `${ordinalNumber}th`;
    }

    switch (ordinalNumber % 10) {
      case 1:
        return `${ordinalNumber}st`;
      case 2:
        return `${ordinalNumber}nd`;
      case 3:
        return `${ordinalNumber}rd`;
      default:
        return `${ordinalNumber}th`;
    }
  });
}

export function formatMsToLocalTime(isoString: string) {
  const date = new Date(isoString);

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  };

  const formatter = new Intl.DateTimeFormat('en-US', options);
  const parts = formatter.formatToParts(date);
  const partsMap = new Map(parts.map((part) => [part.type, part.value]));

  return `${partsMap.get('month')} ${partsMap.get('day')}, ${partsMap.get('year')}, at ${partsMap.get('hour')}:${partsMap.get('minute')} ${partsMap.get('timeZoneName')}`;
}

export function parseTimeLeft(ms: number) {
  if (!ms || ms <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  return {
    days,
    hours: hours % 24,
    minutes: minutes % 60,
    seconds: seconds % 60,
  };
}
